export const storeLinks = {
  googlePlay: '',
  appStore: '',
} as const;

export function isLiveStoreUrl(value: string): boolean {
  return value.startsWith('https://') && value.length > 'https://'.length;
}
